/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetAmplifyCreditsHasPurchasedAtLeastOnce$Params {
}

export function getAmplifyCreditsHasPurchasedAtLeastOnce(http: HttpClient, rootUrl: string, params?: GetAmplifyCreditsHasPurchasedAtLeastOnce$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, getAmplifyCreditsHasPurchasedAtLeastOnce.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

getAmplifyCreditsHasPurchasedAtLeastOnce.PATH = '/api/amplify-credits/has-purchased-at-least-once';
